export default __webpack_public_path__ + "static/media/blog-2.910175f2.jpg";